import { all, put, takeEvery, call } from 'redux-saga/effects';
import {
  getMarketingChannelDataFail,
  getMarketingExportFail,
  getMarketingExportSuccess,
} from '../actions';
import get from 'lodash/get';
import { reset, stopSubmit } from 'redux-form';
import { MARKETING_DATA_EXPORT_FORM, MARKETING_DATA_EXPORT_MODAL } from '../constants';
import downloadFile from 'utils/downloadFile';
import fmDate from 'utils/fmDate';
import { showNotificationInfo } from 'modules/notifications/actions';
import { closeModal } from 'components/TP-UI/TPModal/actions';
import showErrorMessage from 'utils/showErrorMessage';

function* handleGetMarketingChannelDataFail(action) {
  yield call(showErrorMessage, action);
}

function* handleGetMarketingExportSuccess(action) {
  const { csv } = action.response.data;
  downloadFile(csv, `registered_users_${fmDate().format('YYYY-MM-DD')}.csv`);
  yield put(showNotificationInfo('File was created successfully'));
  yield put(closeModal(MARKETING_DATA_EXPORT_MODAL));
  yield put(reset(MARKETING_DATA_EXPORT_FORM));
}

function* handleGetMarketingExportFail(action) {
  const { message: errorMessage } = get(action, 'error.data', 'Error');

  yield put(
    stopSubmit(MARKETING_DATA_EXPORT_FORM, {
      _error: errorMessage,
    }),
  );
}

function* watchSaga() {
  yield all([
    takeEvery(getMarketingChannelDataFail, handleGetMarketingChannelDataFail),
    takeEvery(getMarketingExportSuccess, handleGetMarketingExportSuccess),
    takeEvery(getMarketingExportFail, handleGetMarketingExportFail),
  ]);
}

export default watchSaga;
